import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from './responsive';

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  const getIsMobile = () =>
    typeof window !== 'undefined' && window.innerWidth <= breakpoint;

  const [isMobile, setIsMobile] = useState<boolean>(getIsMobile());

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return isMobile;
}







